import React from 'react';
import { NavigationBarOrganism, TitleBarOrganism } from '../../organisms';
import { HeaderProps } from './header.props';

export const HeaderTemplate = (props: HeaderProps) => {
  return (
    <section
      id="navigation"
      className={`fixed top-0 w-full z-40 ${props.addClass}`}
    >
      <TitleBarOrganism links={props.links} addClass={props.addClass} />
      <NavigationBarOrganism productLinks={props.links} />
    </section>
  );
};
